module.exports = __webpack_public_path__ + "static/media/moscow-1.a165d158.jpeg";